export default __webpack_public_path__ + "static/alhussaini-2f951d57bab767f1a567fffceaba571b.mp4";